import { render } from "./UploadForm.vue?vue&type=template&id=e83354cc&ts=true"
import script from "./UploadForm.vue?vue&type=script&lang=ts"
export * from "./UploadForm.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/inputs/form/UploadForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e83354cc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e83354cc', __exports__)) {
    api.reload('e83354cc', __exports__)
  }
  
  module.hot.accept("./UploadForm.vue?vue&type=template&id=e83354cc&ts=true", () => {
    api.rerender('e83354cc', render)
  })

}


export default __exports__